/* ------------------------------------------------------------------------
   Draws the EU notice PDF as an A4 sheet at the full width of its column,
   with a selectable text layer on top (so the text can be copied).
   Uses pdf.js (cdnjs). If anything fails, the picture of the same page that
   is already in the markup simply stays.
   ------------------------------------------------------------------------ */
(function () {
	var PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/';

	function init() {
		var sheet = document.querySelector('[data-kc-pdf]');
		if (!sheet) return;

		var url = sheet.getAttribute('data-kc-pdf');
		var canvas = sheet.querySelector('.kc-legal-paper__canvas');
		var textLayer = sheet.querySelector('.kc-legal-paper__text');
		var pdfDoc = null;
		var renderToken = 0;

		function loadScript(src, cb) {
			var s = document.createElement('script');
			s.src = src;
			s.onload = cb;
			s.onerror = function () {};
			document.head.appendChild(s);
		}

		function render() {
			if (!pdfDoc) return;
			var token = ++renderToken;
			pdfDoc.getPage(1).then(function (page) {
				var cssWidth = sheet.clientWidth;
				if (!cssWidth) return;
				var base = page.getViewport({ scale: 1 });
				var scale = cssWidth / base.width;
				var viewport = page.getViewport({ scale: scale });
				var ratio = window.devicePixelRatio || 1;

				canvas.width = Math.floor(viewport.width * ratio);
				canvas.height = Math.floor(viewport.height * ratio);
				canvas.style.width = viewport.width + 'px';
				canvas.style.height = viewport.height + 'px';
				sheet.style.height = viewport.height + 'px';

				var ctx = canvas.getContext('2d');
				ctx.setTransform(1, 0, 0, 1, 0, 0);

				var task = page.render({
					canvasContext: ctx,
					viewport: viewport,
					transform: ratio !== 1 ? [ratio, 0, 0, ratio, 0, 0] : null
				});

				task.promise.then(function () {
					if (token !== renderToken) return;
					return page.getTextContent().then(function (content) {
						if (token !== renderToken) return;
						textLayer.innerHTML = '';
						textLayer.style.width = viewport.width + 'px';
						textLayer.style.height = viewport.height + 'px';
						window.pdfjsLib.renderTextLayer({
							textContentSource: content,
							container: textLayer,
							viewport: viewport,
							textDivs: []
						});
						sheet.classList.add('is-rendered');
					});
				}).catch(function () {});
			}).catch(function () {});
		}

		loadScript(PDFJS + 'pdf.min.js', function () {
			if (!window.pdfjsLib) return;
			/* The worker lives on another origin, so start it through a blob. */
			try {
				var blob = new Blob(["importScripts('" + PDFJS + "pdf.worker.min.js');"], { type: 'text/javascript' });
				window.pdfjsLib.GlobalWorkerOptions.workerSrc = URL.createObjectURL(blob);
			} catch (e) {
				window.pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS + 'pdf.worker.min.js';
			}
			window.pdfjsLib.getDocument(url).promise.then(function (doc) {
				pdfDoc = doc;
				render();
				var timer;
				window.addEventListener('resize', function () {
					clearTimeout(timer);
					timer = setTimeout(render, 150);
				});
			}).catch(function () {});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
